import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Description = styled.div`
  p {
    /* margin: 0; */
    /* color: ${COLORS.BODY_TEXT} !important; */
    /* span {
      font-size: 14px !important;
    }
    strong {
      font-weight: 700;
      margin: 0;
      color: ${COLORS.BODY_TEXT} !important;
    } */
  }
`;

export { Description };
